import { Platform } from "react-native";
import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
import { AppTracking as unavailableAppTracking } from "./unavailable";
var hybrid;
function native() {
  if (Platform.OS !== "ios") throw new Error("AppTracking requires an iOS native build");
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneAppTracking");
  return hybrid;
}
function getPermissionStatus() {
  try {
    return native().getPermissionStatus();
  } catch (error) {
    return rethrowNativeError(error);
  }
}
function requestPermission() {
  return native().requestPermission().catch(rethrowNativeError);
}
var nativeAppTracking = Object.freeze({
  getPermissionStatus,
  requestPermission
});
var AppTracking = Platform.OS === "android" ? unavailableAppTracking : nativeAppTracking;
export {
  AppTracking
};
//# sourceMappingURL=index.native.js.map
